import React, { useState } from "react";
import "./Card.scss";
import { Calendar, MapPinTextured } from "../images/index";

interface EventCardProps {
  image: string;
  eyebrow: string;
  eyebrowColor?: string;
  title: string;
  date: string;
  location: { city: string; region: string; regionLink: string };
  summary: string;
  maxSummaryLength?: number;
  url?: string;
  hide_media: boolean;
}

const removeEventsFromEyebrow = (title: string): string => {
  return title.replace(/\b\s*events\b$/i, '');
};

export const Card: React.FC<EventCardProps> = ({
  image,
  eyebrow,
  eyebrowColor,
  title,
  date,
  location,
  summary,
  maxSummaryLength = 160,
  url,
  hide_media,
}) => {
  const [isCardHovered, setIsCardHovered] = useState(false);

  const truncatedSummary =
    summary.length > maxSummaryLength
      ? `${summary.substring(
          0,
          summary.lastIndexOf(" ", maxSummaryLength)
        )}...`
      : summary;

  const processedEyebrow = removeEventsFromEyebrow(eyebrow);

  const handleHover = () => {
    setIsCardHovered(true);
  };

  const handleBlur = () => {
    setIsCardHovered(false);
  };

  return (
    <div className="card">
      {url && (
        <a
          href={url}
          className="card__url"
          onMouseEnter={handleHover}
          onMouseLeave={handleBlur}
          onFocus={handleHover}
          onBlur={handleBlur}
        >
          <span className="screen-reader-text">{title}</span>
        </a>
      )}
      <div
        className={`card__eyebrow utility-small-bold`}
        style={{ backgroundColor: eyebrowColor ?? undefined, display: processedEyebrow === "Event" ? "none" : "block" }}
        dangerouslySetInnerHTML={{ __html: processedEyebrow }}
      />
      <img 
        src={hide_media ? "/wp-content/themes/tror/images/jpgs/placeholder.jpg" : image} 
        alt={hide_media ? "" : title} 
        className={`card__image ${hide_media ? "card__image--fallback" : ""}`} 
      />
      <div className="card__content">
        <h4
          className="card__title utility-large"
          dangerouslySetInnerHTML={{ __html: title }}
          style={{ textDecoration: isCardHovered ? "underline" : "none" }}
        />
        <div className="card__info">
          <div className="card__date">
            <Calendar className="card__icon" /> {date ?? "..."}
          </div>
          <div className="card__location">
            <MapPinTextured className="card__icon card__icon--map-pin" />
            <div className="card__location__city-location">
              {location ? (
                <>
                  {location.city ? `${location.city}, ` : ""}

                  {location.regionLink ? (
                    <a href={location.regionLink} className="card__location__region">
                      <span
                        dangerouslySetInnerHTML={{ __html: location.region }}
                      ></span>
                    </a>
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{ __html: location.region }}
                    ></span>
                  )}
                </>
              ) : (
                "..."
              )}
            </div>
          </div>
        </div>
        <p
          className="card__summary utility-body"
          dangerouslySetInnerHTML={{ __html: truncatedSummary }}
        />
      </div>
    </div>
  );
};
